import { render } from "./Binance.vue?vue&type=template&id=339fbd9c"
import script from "./Binance.vue?vue&type=script&lang=js"
export * from "./Binance.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__